import { Component, OnInit } from '@angular/core';
import { ProductService } from '../../services/productservice';
import { Product } from '../../domain/product';
import {MenuItem} from 'primeng/api';


@Component({
  selector: 'app-companies',
  templateUrl: './companies.component.html',
  styleUrls: ['./companies.component.scss']
})
export class CompaniesComponent implements OnInit {
  visibleSidebar2;
  products: Product[];
  items: MenuItem[];

  constructor(private productService: ProductService) { }

  ngOnInit() {
    this.productService.getProductsSmall().then(data => this.products = data);
    this.items = [
      {label: 'Menu'},
      {label: 'Menu Active'},
    ];
  }

}
